import React from "react";
import Spinner from "../../../../Spinner";
import { jsx as _jsx } from "react/jsx-runtime";
function CustomLoadingIndicator() {
  return /*#__PURE__*/_jsx(Spinner, {
    size: "sm"
  });
}
CustomLoadingIndicator.displayName = "CustomLoadingIndicator";
export default CustomLoadingIndicator;